import script from "./OnboardingAiStepper.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiStepper.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiStepper.vue?vue&type=style&index=0&id=5196099c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5196099c"]])

export default __exports__